// Postcode Anywhere Javascript Popup Service
// Version 3.0 (SlipStream engine enabled)
// Automatically generated on 18/06/2012 17:27:54 from WEB-2-3
// (c) 2001-2012 Postcode Anywhere (Europe) Ltd
import Track from '../v2/utils/tracking';

const pcaBaseUrlAH71 = 'https://services.postcodeanywhere.co.uk/popups';
const pcaLicenseKeyAH71 = 'AH71-DA52-HB93-WA19';
const pcaAccountCodeAH71 = 'THEHU11117';
const pcaMachineIdAH71 = '';
const pcaInlineServiceAH71 = `${pcaBaseUrlAH71}/inline.aspx`;
const pcaReturnUrlAH71 = window.location;
let pcaNextStepAH71 = '';
let _callbackToSetAddress;

function pcaGetFieldAH71(what) {
  return document.querySelector(what);
}

function pcaFindAH71() {
  let strPostcode;
  
  if (pcaGetFieldAH71('.delivery-postcode-field[name="deliveryAddress.postCode"]') === null) {
    strPostcode = pcaGetFieldAH71('.delivery-postcode-field[name="editAddressForm.deliveryAddress.postCode"]').value
  } else if (pcaGetFieldAH71('.delivery-postcode-field[name="deliveryAddress.postCode"]') !== null) {
    strPostcode = pcaGetFieldAH71('.delivery-postcode-field[name="deliveryAddress.postCode"]').value
  } else Track.track('Failed to find element for PCA')
  
  if (strPostcode.length <= 4) {
    pcaByOutcodeBeginAH71(strPostcode);
  } else {
    pcaByPostcodeBeginAH71(strPostcode);
  }
}

function pcaByPostcodeBeginAH71(postcode) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  const strUrl = `${pcaInlineServiceAH71}?account_code=${escape(pcaAccountCodeAH71)}&license_code=${escape(pcaLicenseKeyAH71)}&machine_id=${escape(pcaMachineIdAH71)}&return_to=${escape(pcaReturnUrlAH71)}&action=lookup&type=by_postcode&callback=pcaByPostcodeEndAH71&postcode=${escape(postcode)}`;
  
  // Clear the list
  document.getElementById('pcaSelectAH71').length = 0;
  
  // Set the next step
  pcaNextStepAH71 = 'FETCH';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function handlePCACallback() {
  let intCounter = 0;
  
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else {
    // Add the items to the list
    const select = document.getElementById('pcaSelectAH71');
    select.length = pcaRecordCount;
    
    for (intCounter = 0; intCounter < pcaRecordCount; intCounter++) {
      select.options[intCounter].text = pca_description[intCounter];
      select.options[intCounter].value = pca_id[intCounter];
    }
    
    const fallbackOpts = document.createElement('option');
    fallbackOpts.setAttribute('selected', 'selected');
    fallbackOpts.setAttribute('disabled', 'disabled');
    fallbackOpts.innerHTML = 'Please select...';
  
    select.add(fallbackOpts, select.firstChild);
  
    // Check if there were any items listed
    if (pcaRecordCount == 0) {
      select.length = 1;
      select.options[intCounter].text = siteObj.props['checkout-pca-no-matching-items-text'];
      select.options[intCounter].value = '';
      select.disabled = true;
    } else {
      select.selectedIndex = 0; // Fixes strange bug on FF where going from disabled to non-disabled option wouldn't update.
      select.disabled = false;
    }
    
    // Show the list
    select.style.visibility = 'visible';
    document.getElementById('pcaDivAH71').style.display = '';
  }
}

const pcaByPostcodeEndAH71 = handlePCACallback;

function pcaByOutcodeBeginAH71(outcode) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceAH71}?account_code=${escape(pcaAccountCodeAH71)}&license_code=${escape(pcaLicenseKeyAH71)}&machine_id=${escape(pcaMachineIdAH71)}&return_to=${escape(pcaReturnUrlAH71)}&action=lookup&type=by_outcode&callback=pcaByOutcodeEndAH71&outcode=${escape(outcode)}`;
  
  // Clear the list
  document.getElementById('pcaSelectAH71').length = 0;
  
  // Set the next step
  pcaNextStepAH71 = 'BY_LOCALITYKEY';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

const pcaByOutcodeEndAH71 = handlePCACallback;

function pcaByLocalityKeyBeginAH71(localityKey) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceAH71}?account_code=${escape(pcaAccountCodeAH71)}&license_code=${escape(pcaLicenseKeyAH71)}&machine_id=${escape(pcaMachineIdAH71)}&return_to=${escape(pcaReturnUrlAH71)}&action=lookup&type=by_localitykey&callback=pcaByLocalityKeyEndAH71&localitykey=${escape(localityKey)}`;
  
  // Clear the list
  document.getElementById('pcaSelectAH71').length = 0;
  
  // Set the next step
  pcaNextStepAH71 = 'BY_STREETKEY';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

const pcaByLocalityKeyEndAH71 = handlePCACallback;

function pcaByStreetKeyBeginAH71(streetKey) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  const strUrl = `${pcaInlineServiceAH71}?account_code=${escape(pcaAccountCodeAH71)}&license_code=${escape(pcaLicenseKeyAH71)}&machine_id=${escape(pcaMachineIdAH71)}&return_to=${escape(pcaReturnUrlAH71)}&action=lookup&type=by_streetkey&callback=pcaByStreetKeyEndAH71&streetkey=${escape(streetKey)}`;
  
  // Clear the list
  document.getElementById('pcaSelectAH71').length = 0;
  
  // Set the next step
  pcaNextStepAH71 = 'FETCH';
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function pcaByStreetKeyEndAH71() {
  let intCounter = 0;
  
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else {
    // Add the items to the list
    const select = document.getElementById('pcaSelectAH71');
    select.length = pcaRecordCount;
  
    for (intCounter = 0; intCounter < pcaRecordCount; intCounter++) {
      select.options[intCounter].text = pca_description[intCounter];
      select.options[intCounter].value = pca_id[intCounter];
    }
  
    // Check if there were any items listed
    if (pcaRecordCount == 0) {
      select.length = 1;
      select.options[intCounter].text = siteObj.props['checkout-pca-no-matching-items-text'];
      select.options[intCounter].value = '';
      select.disabled = true;
    } else {
      select.selectedIndex = 0;
      select.disabled = false;
    }
  
    // Show the list
    select.style.visibility = 'visible';
    select.onblur = pcaDoSelectAH71;
    document.getElementById('pcaDivAH71').style.display = '';
  }
}

function pcaDoSelectAH71(event) {
  const {value} = event.target;
  switch (pcaNextStepAH71) {
    case 'FETCH':
      pcaFetchBeginAH71(value);
      break;
    case 'BY_LOCALITYKEY':
      pcaByLocalityKeyBeginAH71(document.getElementById('pcaSelectAH71').value);
      break;
    case 'BY_STREETKEY':
      pcaByStreetKeyBeginAH71(document.getElementById('pcaSelectAH71').value);
      break;
  }
}

function pcaFetchBeginAH71(addressId) {
  let scriptTag = document.getElementById('pcaScript');
  const headTag = document.getElementsByTagName('head').item(0);
  
  document.getElementById('pcaDivAH71').style.display = 'none';
  
  // Build the url
  const strUrl = `${pcaInlineServiceAH71}?account_code=${escape(pcaAccountCodeAH71)}&license_code=${escape(pcaLicenseKeyAH71)}&machine_id=${escape(pcaMachineIdAH71)}&return_to=${escape(pcaReturnUrlAH71)}&action=fetch&callback=pcaFetchEndAH71&id=${escape(addressId)}`;
  
  // Make the request
  if (scriptTag) {
    try {
      headTag.removeChild(scriptTag);
    } catch (ex) {
      // Ignore
    }
  }
  scriptTag = document.createElement('script');
  scriptTag.src = strUrl;
  scriptTag.type = 'text/javascript';
  scriptTag.id = 'pcaScript';
  headTag.appendChild(scriptTag);
}

function pcaFetchEndAH71() {
  // Test for an error
  if (pcaSchema.length == 2) {
    // Show the error message
    Track.track(pca_message[0]);
  } else if (_callbackToSetAddress) {
    const addressValues = {
      county: pca_PAF_COUNTY[0],
      nameNumber: pca_PAF_BUILDING[0],
      postCode: pca_PAF_POSTCODE[0],
      streetName: pca_PAF_STREET[0],
      townCity: pca_PAF_TOWN[0],
      addressLine2: pca_PAF_DISTRICT[0],
      companyName: pca_PAF_COMPANY[0],
    };
    _callbackToSetAddress(addressValues);
  } else {
    // Copy the items to the form
    pcaSetFieldAH71('deliveryAddress.county', pca_PAF_COUNTY[0]);
    pcaSetFieldAH71('deliveryAddress.nameNumber', pca_PAF_BUILDING[0]);
    pcaSetFieldAH71('deliveryAddress.streetName', pca_PAF_STREET[0]);
    pcaSetFieldAH71('deliveryAddress.townCity', pca_PAF_TOWN[0]);
    pcaSetFieldAH71('deliveryAddress.addressLine2', pca_PAF_DISTRICT[0]);
    pcaSetFieldAH71('deliveryAddress.companyName', pca_PAF_COMPANY[0]);
  }
}

function pcaSetFieldAH71(what, newValue) {
  for (let intFormCounter = 0; intFormCounter <= document.forms.length - 1; intFormCounter++) {
    for (let elementCounter = 0; elementCounter <= document.forms[intFormCounter].length - 1; elementCounter++) {
      if (document.forms[intFormCounter].elements[elementCounter].name == what) {
        document.forms[intFormCounter].elements[elementCounter].value = newValue;
        document.forms[intFormCounter].elements[elementCounter].dispatchEvent(new Event('change'));
      }
    }
  }
}

function setCallbackToSetAddress(callbackToSetAddress) {
  _callbackToSetAddress = callbackToSetAddress;
}

window.pcaByPostcodeEndAH71 = pcaByPostcodeEndAH71;
window.pcaByOutcodeEndAH71 = pcaByOutcodeEndAH71;
window.pcaByLocalityKeyEndAH71 = pcaByLocalityKeyEndAH71;
window.pcaByStreetKeyEndAH71 = pcaByStreetKeyEndAH71;
window.pcaFetchEndAH71 = pcaFetchEndAH71;

export default {
  find: pcaFindAH71,
  doSelect: pcaDoSelectAH71,
  setCallbackToSetAddress,
  embedCode: 'AH71',
};
